import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.financial.metric.card');
import { Input } from '@angular/core';

interface MetricComparison {
    status?: string;
    percentile?: number | null;
    industry_median?: number | null;
    percentile_25?: number | null;
    percentile_75?: number | null;
    rank?: number | null;
    ranking_total?: number;
}

interface FinancialMetricData {
    label?: string;
    value?: number | null;
    unit?: string;
    status?: string;
    reason?: string;
    comparison?: MetricComparison;
}

@Component({
    selector: 'wiz-component-reviewops-financial-metric-card',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.financial.metric.card/view.scss */
/* src/app/component.reviewops.financial.metric.card/view.scss: no such file or directory */`],
})
export class ComponentReviewopsFinancialMetricCardComponent {
    @Input() metric: FinancialMetricData = {};
    @Input() position: number = 1;

    public display(value: number | null | undefined, unit: string = ''): string {
        if (value === null || value === undefined) return 'UNAVAILABLE';
        return Number(value).toLocaleString('ko-KR', { maximumFractionDigits: 1 }) + unit;
    }

    public percentileText(): string {
        const percentile = this.metric.comparison?.percentile;
        if (percentile === null || percentile === undefined) return '—';
        return `${Math.round(percentile)}th`;
    }
}

export default ComponentReviewopsFinancialMetricCardComponent;